import _defineProperty from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["image", "name"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

/* eslint-disable react/jsx-no-useless-fragment */
export function Avatar(props) {
  var image = props.image,
      name = props.name,
      passThroughProps = _objectWithoutProperties(props, _excluded);

  return /*#__PURE__*/_jsx(_Fragment, {
    children: image ? /*#__PURE__*/_jsx("img", _objectSpread({
      src: image,
      alt: name,
      className: "h-10 w-10 rounded-xl"
    }, passThroughProps)) : /*#__PURE__*/_jsx("span", _objectSpread(_objectSpread({
      className: "bg-teal inline-flex h-8 w-8 items-center justify-center rounded-xl text-xl font-bold text-white"
    }, passThroughProps), {}, {
      children: (name === null || name === void 0 ? void 0 : name.charAt(0)) || ''
    }))
  });
}